import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PrivateExitDocumentManagement from '@/types/table/privateExitDocumentManagement';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PrivateExitDocumentManagementData extends PrivateExitDocumentManagement {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PrivateExitDocumentManagementController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PrivateExitDocumentManagementData>>(API_CONTEXT + '/app/privateExitDocumentManagement/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PrivateExitDocumentManagementData>(API_CONTEXT + '/app/privateExitDocumentManagement/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/privateExitDocumentManagement/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/privateExitDocumentManagement/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/privateExitDocumentManagement/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/privateExitDocumentManagement/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/privateExitDocumentManagement/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/privateExitDocumentManagement/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/privateExitDocumentManagement/deleteBatch', params, httpOptions);
  }
}
